<template>
  <div class="ods-status-message ods-margin-top-2 ods-margin-bottom-5" :class="meldingstypeVelger()">
    <h2 class="ods-status-message__heading">
      <span class="ods-status-message__icon ods-icon--information" aria-hidden="true" />{{ tittel }}
    </h2>
    <p class="ods-status-message__content">
      {{ melding }}
    </p>
    <p class="ods-status-message__date">
      {{ meldingsDato }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'OdsStatusMessage',
  props: {
    tittel: {
      type: String,
      required: true,
    },
    melding: {
      type: String,
      required: true,
    },
    meldingsDato: { type: String, default: '' },
    meldingstype: { type: String, default: '' },
  },
  methods: {
    meldingstypeVelger() {
      const meldingstypeKlasser = {
        INFO: 'ods-status-message--info',
        SUCCESS: 'ods-status-message--success',
        WARNING: 'ods-status-message--warning',
        DANGER: 'ods-status-message--danger',
      };

      return meldingstypeKlasser[this.meldingstype.toUpperCase()] || '';
    },
  },
};
</script>
